import { Schema } from "@effect/schema";
import { Address, PositionType, ProtocolKey } from "@silo/types";
import { Context, Ref } from "effect";

export const MarketsStrategy = Schema.Literal(
  "graph",
  "kv",
  "static"
).annotations({ identifier: "MarketsStrategy" });
export type MarketsStrategy = typeof MarketsStrategy.Type;

export const FallbackStrategy = MarketsStrategy.pipe(
  Schema.pickLiteral("kv", "static")
);
export type FallbackStrategy = typeof FallbackStrategy.Type;

export interface IncentivizedShareToken {
  protocolKey: ProtocolKey;
  shareTokenAddress: Address;
  type: PositionType;
}

export class IncentivizedShareTokensService extends Context.Tag(
  "IncentivizedShareTokensService"
)<IncentivizedShareTokensService, Ref.Ref<IncentivizedShareToken[]>>() {}
